import { z } from 'zod';
import { McpServerNameSchema } from '../ids.ts';

export const ToolSourceKindSchema = z.enum(['mcp']);
export type ToolSourceKind = z.infer<typeof ToolSourceKindSchema>;

export const TOOL_DESCRIPTION_MAX_CHARS = 2048;

export const ToolOverrideSchema = z.object({
  source: McpServerNameSchema,
  toolName: z.string().min(1).max(256),
  enabled: z.boolean(),
  description: z.string().trim().min(1).max(TOOL_DESCRIPTION_MAX_CHARS).nullable(),
});
export type ToolOverride = z.infer<typeof ToolOverrideSchema>;
